// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Spectrum = function Spectrum(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8.877 6.5H.622a.289.289 0 00-.289.289v2.425a.289.289 0 00.289.286h8.255a.289.289 0 00.289-.289V6.789a.289.289 0 00-.289-.289zm-6.9 1.811h-.76v-.755h.756zM8.877 10.1H.622a.289.289 0 00-.289.289v2.421a.289.289 0 00.289.289h8.255a.289.289 0 00.289-.289v-2.425a.289.289 0 00-.289-.289zm-6.9 1.88h-.76v-.756h.756z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M15.647 3.742a.331.331 0 00-.192-.262L9.4.745h-.014a.337.337 0 00-.25 0h-.011L3.063 3.479a.331.331 0 00-.192.262 13.708 13.708 0 00.044 2.052h.928a11.609 11.609 0 01-.012-1.426.281.281 0 01.163-.22L9.16 1.812a.284.284 0 01.191 0l5.172 2.332a.281.281 0 01.163.22c.007.076.579 7.628-5.362 9.835a.3.3 0 01-.137 0 7.672 7.672 0 01-.722-.331H6.739a8.538 8.538 0 001.574 1.016c-.013.009.846.381.85.381a.359.359 0 00.187 0s.863-.374.85-.381c6.051-2.959 5.455-11.057 5.447-11.142z"
    }))
  );
};

export default Spectrum;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Spectrum.js
// module id = 1052
// module chunks = 0